export default "__VITE_ASSET__C2qA3Q1B__"